import OrderDTO from "@/dto/order/OrderDTO";
import { openUrl } from "@/utils";
import { InfoCircleFilled } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface WiredOrderInfoProps {
    order: OrderDTO;
}

export function shouldRenderWiredOrderInfo(order: OrderDTO) {
    return !!order._weirdInfo;
}

const WiredOrderInfo: React.FC<WiredOrderInfoProps> = function (props) {
    const { order } = props;

    if (!shouldRenderWiredOrderInfo(order)) return null;

    return (
        <p className="mt5 fb fs14" style={{ color: "red" }}>
            <InfoCircleFilled className="mr5" />
            <span className="mr5">{order._weirdInfo}，不要进行打印发货操作，请联系客服处理</span>
            <Button
                size="small"
                type="link"
                onClick={() => {
                    openUrl("https://v2.fahuoyi.com/cs");
                }}
            >
                联系客服
            </Button>
        </p>
    );
};

export default observer(WiredOrderInfo);
